// src/components/CookieConsent.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  getCookieConsent,
  setCookieConsent,
} from "../utils/cookieConsent";
import mixpanelService from "../services/mixpanel"; // optional: see Step 4

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getCookieConsent();
    // Show banner only if user hasn't made a choice yet
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setCookieConsent("accepted");
    setVisible(false);

    // OPTIONAL: initialize analytics here only after explicit consent
    try {
      mixpanelService.init?.();
    } catch (e) {
      console.error("Mixpanel init failed:", e);
    }
  };

  const handleReject = () => {
    setCookieConsent("rejected");
    setVisible(false);
    // No analytics / marketing cookies here
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-neutral-900/95 text-neutral-50 px-4 py-3">
      <div className="max-w-6xl mx-auto flex flex-wrap items-center gap-3 justify-between">
        <p className="text-sm leading-relaxed flex-1 min-w-[240px]">
          We use cookies to improve your experience, analyze site traffic, and
          personalize content. You can accept or reject non-essential cookies.
          Read our{" "}
          <Link
            to="/privacy-policy"
            className="underline underline-offset-2 text-blue-300 hover:text-blue-200"
          >
            Privacy Policy
          </Link>{" "}
          and{" "}
          <Link
            to="/terms-and-conditions"
            className="underline underline-offset-2 text-blue-300 hover:text-blue-200"
          >
            Terms &amp; Conditions
          </Link>
          .
        </p>

        <div className="flex gap-2 flex-shrink-0">
          <button
            type="button"
            onClick={handleReject}
            className="px-3 py-1.5 text-sm rounded-md border border-neutral-500 font-semibold hover:bg-neutral-800 transition"
          >
            Reject
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="px-4 py-1.5 text-sm rounded-md bg-gradient-to-br from-[#FFD200] to-[#F7971E] hover:bg-gradient-to-bl text-[#1a1a1a] font-semibold transition"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
